/* * @Author: 刘枫 * @Date: 2020-10-29 10:54:19 * @Last Modified by: 李志远 *
@Last Modified time: 2021-10-Sa 01:33:07 * @title: 联盟商家 */

<template>
  <div class="layout-block">
    <div class="right-content">
      <div class="layout">
        <h2>申请联盟商家</h2>
        <div class="main">
          <div class="wrap">
            <div class="open-store">
              <Form
                :model="formItem"
                :label-width="140"
                class="form-wrap"
              >
                <FormItem
                  label="姓名："
                  style="margin-top: 20px"
                >
                  <Input
                    v-model="formItem.name"
                    class="s-input"
                  ></Input>
                </FormItem>
                <FormItem
                  label="商家店铺："
                  style="margin-top: 20px"
                >
                  <Input
                    v-model="formItem.leagueName"
                    class="s-input"
                  ></Input>
                </FormItem>
                <FormItem
                  label="经营类目："
                  style="margin-top: 20px"
                >
                  <Select
                    v-model="formItem.parentId"
                    @on-change="getStoreCat"
                    size="large"
                    placeholder="请选择类目"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in storeCatList"
                      :value="item.catId"
                      :key="item.catId"
                    >{{ item.catName }}</Option>
                  </Select>
                  <Select
                    v-model="formItem.catId"
                    size="large"
                    placeholder="请选择子类目"
                    @on-change="getStoreSonCat"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in storeCatSonList"
                      :value="item.catId"
                      :key="item.catId"
                    >{{ item.catName }}</Option>
                  </Select>
                  <p style="padding-left: 12px">包含范围：{{ catDesc }}</p>
                </FormItem>
                <FormItem
                  label="地区："
                  style="margin-top: 20px"
                >
                  <Select
                    v-model="formItem.provinceid"
                    :label-in-value="true"
                    @on-change="getCityList($event)"
                    size="large"
                    placeholder="请选择省份"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in provinceList"
                      :value="item.regionId"
                      :key="item.regionId"
                    >{{ item.localName }}
                    </Option>
                  </Select>
                  <Select
                    v-model="formItem.cityid"
                    :label-in-value="true"
                    size="large"
                    @on-change="getRegionList($event)"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in cityList"
                      :value="item.regionId"
                      :key="item.regionId"
                    >{{ item.localName }}
                    </Option>
                  </Select>
                  <Select
                    v-model="formItem.regionid"
                    :label-in-value="true"
                    size="large"
                    :transfer="true"
                    @on-change="getVillagesList($event)"
                  >
                    <Option
                      v-for="item in regionList"
                      :value="item.regionId"
                      :key="item.regionId"
                    >{{ item.localName }}
                    </Option>
                  </Select>
                  <Select
                    v-model="formItem.villagesid"
                    :label-in-value="true"
                    size="large"
                    :transfer="true"
                    @on-change="getVillage($event)"
                  >
                    <Option
                      v-for="item in villagesList"
                      :value="item.regionId"
                      :key="item.regionId"
                    >{{ item.localName }}
                    </Option>
                  </Select>
                </FormItem>
                <FormItem
                  label="详细地址："
                  style="margin-top: 20px"
                >
                  <Input
                    v-model="formItem.attr"
                    class="l-input"
                    @on-blur="attrChange"
                  ></Input>
                </FormItem>
                <FormItem
                  label="地图定位："
                  style="margin-top: 20px"
                >
                  <baidu-map
                    class="map"
                    :center="center"
                    @ready="handler"
                    :zoom="zoom"
                    :scroll-wheel-zoom="true"
                  >
                    <bm-marker
                      :position="positions"
                      :dragging="true"
                      @dragend="dragend"
                    >
                    </bm-marker>
                    <!-- <bm-info-window
                      :position="{ lng: formItem.localX, lat: formItem.localY }"
                      :show="infoWindowShow"
                      @clickclose="infoWindowClose"
                    >
                      <p>纬度:{{ formItem.localY }}</p>
                      <p>经度:{{ formItem.localX }}</p>
                    </bm-info-window> -->
                  </baidu-map>
                </FormItem>
                <FormItem
                  label="地理经度："
                  style="margin-top: 20px"
                >
                  <Input
                    v-model="formItem.localX"
                    class="s-input"
                    readonly
                  ></Input>
                </FormItem>
                <FormItem
                  label="地理纬度："
                  style="margin-top: 20px"
                >
                  <Input
                    v-model="formItem.localY"
                    class="s-input"
                    readonly
                  ></Input>
                </FormItem>
                <FormItem
                  label="手机号："
                  style="margin-top: 20px"
                >
                  <Input
                    v-model="formItem.tel"
                    class="s-input"
                  ></Input>
                </FormItem>
                <FormItem
                  label="身份证号："
                  style="margin-top: 20px"
                >
                  <Input
                    v-model="formItem.idNumber"
                    class="s-input"
                  ></Input>
                </FormItem>
                <FormItem
                  label="推荐人："
                  style="margin-top: 20px"
                >
                  <Input
                    v-model="formItem.referer"
                    class="s-input"
                  ></Input>
                </FormItem>
                <FormItem
                  label="所属市场："
                  style="margin-top: 20px"
                >
                  <Input
                    v-model="formItem.legionName"
                    disabled
                    class="s-input"
                  ></Input>
                </FormItem>

                <div class="msgbox">
                  <p><em>*</em>上传身份证照片：</p>
                  <div class="img_box">
                    <div
                      class="demo-upload-list"
                      v-for="(item, index) in idImageUrlList"
                      :key="index"
                    >
                      <img :src="item" />
                      <div class="demo-upload-list-cover">
                        <Icon
                          type="ios-eye-outline"
                          @click.native="handleView(item)"
                        ></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native="handleRemoveListId(index)"
                        ></Icon>
                      </div>
                    </div>
                    <Upload
                      :show-upload-list="false"
                      :before-upload="handleBeforeUploadId"
                      :on-exceeded-size="handleMaxSize"
                      :on-success="handleSuccessListId"
                      :on-format-error="handleFormatError"
                      :format="['jpg', 'jpeg', 'png']"
                      :max-size="2048"
                      :headers="{ 'Auth-Token': upHeaders }"
                      multiple
                      type="drag"
                      :action="UploadUrl()"
                      style="display: inline-block; width: 150px"
                    >
                      <div style="width: 150px; height: 150px; line-height: 150px">
                        <Icon
                          type="ios-camera"
                          size="40"
                        ></Icon>
                      </div>
                    </Upload>
                  </div>
                </div>
                <FormItem
                  label="注册号/社会统一代码："
                  style="margin-top: 20px"
                >
                  <Input
                    v-model="formItem.uniformSocialCreditCode"
                    class="s-input"
                    :maxlength="18"
                  ></Input>
                </FormItem>
                <div class="msgbox">
                  <p><em>*</em>上传营业执照：</p>
                  <div class="img_box">
                    <div
                      class="demo-upload-list"
                      v-for="(item, index) in licenseImageUrlList"
                      :key="index"
                    >
                      <img :src="item" />
                      <div class="demo-upload-list-cover">
                        <Icon
                          type="ios-eye-outline"
                          @click.native="handleView(item)"
                        ></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native="handleRemoveListLicense(index)"
                        ></Icon>
                      </div>
                    </div>
                    <Upload
                      :show-upload-list="false"
                      :before-upload="handleBeforeUploadLicense"
                      :on-exceeded-size="handleMaxSize"
                      :on-success="handleSuccessListLicense"
                      :on-format-error="handleFormatError"
                      :format="['jpg', 'jpeg', 'png']"
                      :max-size="2048"
                      :headers="{ 'Auth-Token': upHeaders }"
                      multiple
                      type="drag"
                      :action="UploadUrl()"
                      style="display: inline-block; width: 150px"
                    >
                      <div style="width: 150px; height: 150px; line-height: 150px">
                        <Icon
                          type="ios-camera"
                          size="40"
                        ></Icon>
                      </div>
                    </Upload>
                  </div>
                </div>
                <div class="msgbox border_b">
                  <p><em>*</em>上传店铺横幅照片：</p>
                  <div class="img_box">
                    <div class="demo-upload-list">
                      <Upload
                        :show-upload-list="false"
                        :on-exceeded-size="handleMaxSize"
                        :on-success="handleSuccessListBanner"
                        :on-format-error="handleFormatError"
                        :format="['jpg', 'jpeg', 'png']"
                        :max-size="2048"
                        :headers="{ 'Auth-Token': upHeaders }"
                        type="drag"
                        :action="UploadUrl()"
                        style="display: inline-block; width: 150px"
                      >
                        <img
                          v-if="storeBannerImg"
                          :src="storeBannerImg"
                        />
                        <input
                          type="hidden"
                          id="storeBannerImg"
                          value="storeBannerUrl"
                        />
                        <div style="
                            width: 150px;
                            height: 150px;
                            line-height: 150px;
                          ">
                          <Icon
                            type="ios-camera"
                            size="40"
                          ></Icon>
                        </div>
                      </Upload>
                      <div
                        class="demo-upload-list-cover"
                        v-show="storeBannerImg"
                      >
                        <Icon
                          type="ios-eye-outline"
                          @click.native="handleView(storeBannerImg)"
                        ></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native="handleRemoveListBanner()"
                        ></Icon>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="msgbox">
                  <p><em>*</em>上传店铺照片：</p>
                  <div class="img_box">
                    <div
                      class="demo-upload-list"
                      v-for="(item, index) in shopImageUrlList"
                      :key="index"
                    >
                      <img :src="item" />
                      <div class="demo-upload-list-cover">
                        <Icon
                          type="ios-eye-outline"
                          @click.native="handleView(item)"
                        ></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native="handleRemoveListShop(index)"
                        ></Icon>
                      </div>
                    </div>
                    <Upload
                      :show-upload-list="false"
                      :before-upload="handleBeforeUploadShop"
                      :on-exceeded-size="handleMaxSize"
                      :on-success="handleSuccessListShop"
                      :on-format-error="handleFormatError"
                      :format="['jpg', 'jpeg', 'png']"
                      :max-size="2048"
                      :headers="{ 'Auth-Token': upHeaders }"
                      multiple
                      type="drag"
                      :action="UploadUrl()"
                      style="display: inline-block; width: 150px"
                    >
                      <div style="width: 150px; height: 150px; line-height: 150px">
                        <Icon
                          type="ios-camera"
                          size="40"
                        ></Icon>
                      </div>
                    </Upload>
                  </div>
                </div>
              </Form>
              <div class="regis_box">
                <input
                  class="regis_ent"
                  type="button"
                  value="立即申请"
                  id="discussBtn"
                  v-on:click="handleSubmit()"
                />
              </div>
              <Modal
                title="图片预览"
                v-model="visible"
              >
                <img
                  :src="showImageUrl"
                  v-if="visible"
                  style="width: 100%"
                />
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSession, getNowFormatDate } from "utils/tool";
import {
  getAddressInfo,
  isApplyLeague,
  applyLeague,
  reApplyLeague,
  getStoreCat,
  getArmyGroupDatas,
  getListJsonByPrimaryKey,
  getUserLegionInfo,
} from "api/user";
import { encryptDes } from "utils/des";

export default {
  data() {
    return {
      status: "", //0重新申请;1申请
      formItem: {
        parentId: "", //经营类目父级ID
        catId: "", //经营类目ID
        leagueId: "", //联盟商家Id
        name: "", //姓名
        leagueName: "", //店铺名称
        attr: "", //详细地址
        localX: "", //经度
        localY: "", //纬度
        tel: "", //电话
        idNumber: "", //身份证号
        referer: "", //推荐人
        provinceid: "", // 省id
        cityid: "", // 市id
        regionid: "", // 区域id
        villagesid: "", // 乡镇/街道code
        provinceName: "", // 省
        cityName: "", // 市
        regionName: "", // 	区域
        villagesName: "", // 乡镇/街道名称
        legionId: 1, // 军团id
        legionName: "", // 军团名字
        uniformSocialCreditCode: "", // 社会信用代码
      },
      searchJingwei: "",
      keyword: "",
      legionId: 1,
      catDesc: "",
      upHeaders: "", //图片上传请求头、
      uploadList: [],
      zoom: 16,
      center: { lng: 0, lat: 0 }, //地图中心点
      positions: { lng: 0, lat: 0 }, //地图标记点

      MEMBER_HOST: process.env.PROTOCOL + "://" + process.env.MEMBER_HOST,
      showImageUrl: "", //预览图片地址
      visible: false, //预览图片是否显示
      storeBannerImg: "", //横幅图片
      storeBannerUrl: "", //上传横幅地址
      idImageUrlList: [], //身份证预览数组
      idUrlList: [], //上传身份证img数组
      licenseImageUrlList: [], //营业执照预览数组
      licenseUrlList: [], //上传营业执照图片img数组
      shopImageUrlList: [], //本地店铺预览数组
      shopUrlList: [], //上传店铺图片img数组
      addressAll: {}, //保存全部数据
      provinceList: [], //省
      cityList: [], //市
      regionList: [], //区
      villagesList: [], // 乡镇
      storeCatList: [], //经营类目
      storeCatSonList: [], //经营子类目
      armyGroupList: [], // 军团信息
      teamOptions: [], // 过滤的军团信息
      infoWindowShow: false,
    };
  },
  created() {
    this.isApplyLeague();
    this.getUserLegionInfo();
    setTimeout(() => {
      //获取经营类目
      this.getStoreCat();
      // 获取军团信息
      this.getArmyGroupDatas();
      if (localStorage.getItem("townList")) {
        this.addressAll = JSON.parse(localStorage.getItem("townList")).data;
        this.provinceList = JSON.parse(
          localStorage.getItem("townList")
        ).data.provinceList;
      } else {
        this.getProvinceList();
      }

      this.getUpHeaders();
    }, 100);
  },
  mounted() {},
  methods: {
    getUserLegionInfo() {
      getUserLegionInfo({ sid: localStorage.getItem("sid") }).then((res) => {
        if (res.result == 1) {
          this.formItem.legionId = res.data.legionId;
          this.formItem.legionName = res.data.legionName;
        }
      });
    },
    finishLoad(e) {
      this.$nextTick(() => {
        if (e && e.Xr && e.Xr[0]) {
          let allOverlay = this.map;
          this.map.clearOverlays(allOverlay[allOverlay.length - 1]);
          const point = e.Xr[0].point;
          this.addMarker(point);
        }
      });
    },
    addMarker(point) {
      let that = this;
      const map = that.map;
      const BMap = that.map;
      var marker = new BMap.Marker(point);
      marker.enableDragging();
      marker.addEventListener("draggend", function (e) {
        const gc = new that.BMap.Geocoder();
        gc.getLocation(e.point, function (rs) {
          if (rs) {
            console.log(rs.point, "*************");
          }
        });
      });
    },
    attrChange(val) {
      console.log(this.formItem.attr, "this.formItem.attr");
      setTimeout(() => {
        if (
          this.formItem.attr &&
          this.formItem.provinceName &&
          this.formItem.cityName &&
          this.formItem.regionName &&
          this.formItem.villagesName
        ) {
          let that = this;
          let myGeo = new this.BMap.Geocoder();
          //逆地址解析
          myGeo.getPoint(
            this.formItem.provinceName +
              this.formItem.cityName +
              this.formItem.regionName +
              this.formItem.villagesName +
              this.formItem.attr,
            function (point) {
              if (point) {
                that.formItem.localX = point.lng;
                that.formItem.localY = point.lat;
                that.center = that.positions = {
                  lng: point.lng,
                  lat: point.lat,
                };
                that.map.centerAndZoom(point, 15);
              }
            }
          );
        }
      }, 1000);
    },
    // 获取军团信息
    getArmyGroupDatas() {
      getArmyGroupDatas().then((res) => {
        this.armyGroupList = res.data;
        this.teamOptions = [
          {
            legionId: 1,
            legionName: "其它",
          },
        ];
      });
    },
    clearHandler() {
      this.teamOptions = [
        {
          legionId: 1,
          legionName: "其它",
        },
      ];
    },
    queryChange(value) {
      if (!value) {
        this.teamOptions = [
          {
            legionId: 1,
            legionName: "其它",
          },
        ];
      } else {
        this.teamOptions = this.armyGroupList.filter((item) => {
          return item.legionName.indexOf(value) > -1;
        });
      }
    },
    // 选择军团信息
    selectlegionHandle(value) {
      if (value) {
        this.formItem.legionId = value.value;
        this.formItem.legionName = value.label;
      }
    },
    /*BMap是百度地图的对象，map是地图对象，可以调用对应的地图方法，比如添加marker */
    handler({ BMap, map }) {
      map.enableScrollWheelZoom(true);
      const _this = this;
      const geolocation = new BMap.Geolocation();
      //获取当前坐标
      geolocation.getCurrentPosition(
        function (r) {
          _this.formItem.localX = r.longitude;
          _this.formItem.localY = r.latitude;
          _this.center = _this.positions = {
            lng: r.longitude,
            lat: r.latitude,
          };
          // 自定义覆盖物
          _this.initLocation = true;
        },
        { enableHighAccuracy: true }
      );

      window.map = map;
      // 赋值，方便调用，本节被用到
      this.BMap = BMap;
      this.map = map;
      $(".map div").css({ position: "absolute", left: "10px" });
    },
    //拖拽获取经纬度
    dragend(e) {
      const gc = new this.BMap.Geocoder();
      const _self = this;
      gc.getLocation(e.point, function (res) {
        _self.formItem.localX = res.point.lng;
        _self.formItem.localY = res.point.lat;
      });
    },
    // 修改表单数据
    setFromData(data) {
      var objData = data;
      if (data.status !== 3) {
        this.formItem = {
          name: "", //姓名
          leagueName: "", //店铺名称
          attr: "", //详细地址
          localX: "", //经度
          localY: "", //纬度
          tel: "", //电话
          idNumber: "", //身份证号
          referer: "", //推荐人
          provinceid: "", // 省id
          cityid: "", // 市id
          regionid: "", // 区域id
          villagesid: "", // 乡镇id
          provinceName: "", // 省名字
          cityName: "", // 市名字
          regionName: "", // 区域名字
          villagesName: "", // 乡镇/街道名称
          parentId: "",
          catId: "",
          legionId: 1, // 军团id
          uniformSocialCreditCode: "",
          // legionName: "其他", // 军团名字
        };
      } else {
        this.cityList = this.addressAll.cityList.filter(
          (v) => v.parentRegionId == objData.provinceid
        );
        this.regionList = this.addressAll.areaList.filter(
          (v) => v.parentRegionId == objData.cityid
        );
        //处理数据
        if (!objData.parentId) {
          objData.parentId = objData.catId;
        }
        this.formItem = Object.assign({}, objData);
        this.getListJsonByPrimaryKey();
        this.leagueId = objData.leagueId;
        this.storeBannerImg = objData.storeBannerImg;
        this.idImageUrlList = this.toArr(objData.idImg);
        this.licenseImageUrlList = this.toArr(objData.licenseImg);
        this.shopImageUrlList = this.toArr(objData.shopImg);
        this.getStoreCat(this.formItem.parentId, objData);
      }
    },
    //查询是否申请过联盟商家
    isApplyLeague() {
      isApplyLeague({}).then((res) => {
        if (res.resCode == 1) {
          if (res.data && res.data.status == 3) {
            this.status = 0;
            this.formItem.leagueId = res.data.leagueId;
            this.setFromData(res.data);
          } else {
            this.status = 1;
            this.setFromData("");
          }
        }
      });
    },
    getStoreCat(parentId = 0, data) {
      getStoreCat({ parentId: parentId }).then((res) => {
        if (parentId == 0) {
          this.storeCatList = res.data;
        } else {
          this.storeCatSonList = res.data;
        }
        this.formItem.catId = "";
        this.catDesc = "";
        //第一次提交赋值
        if (data) {
          this.formItem.catId = data.catId;
          this.getStoreSonCat(data.catId);
        }
      });
    },
    getStoreSonCat(item) {
      if (!item) {
        return;
      }
      let res = this.storeCatSonList.filter((v) => v.catId == item);
      this.catDesc = res.length > 0 ? res[0].catDesc : "";
    },
    // 获取省列表
    async getProvinceList() {
      let resp = await getAddressInfo();
      this.addressAll = resp.data;
      this.provinceList = resp.data.provinceList;
      return resp.data;
    },
    // 根据省ID获取市列表
    getCityList(item, index) {
      if (!item.value) return;
      this.formItem.provinceName = item.label.replace("\n", "");
      this.cityList = this.addressAll.cityList.filter(
        (v) => v.parentRegionId == item.value
      );
      this.formItem.cityid = "";
      this.formItem.regionid = "";
      this.formItem.villagesid = "";
    },
    // 根据市ID获取区列表
    getRegionList(item) {
      if (!item) return;
      this.formItem.cityName = item.label.replace("\n", "");
      this.regionList = this.addressAll.areaList.filter(
        (v) => v.parentRegionId == item.value
      );
      this.formItem.regionid = "";
      this.formItem.villagesid = "";
    },
    // 根据区县ID获取乡镇列表
    getVillagesList(item) {
      if (!item) return;
      this.formItem.regionName = item.label.replace("\n", "");
      getListJsonByPrimaryKey({ regionId: item.value }).then((res) => {
        this.villagesList = res;
      });
      this.formItem.villagesid = "";
    },
    getVillage(item) {
      console.log(item, "item--------");
      this.formItem.villagesName = item.label.replace("\n", "");
      this.formItem.villagesid = item.value;
    },

    getListJsonByPrimaryKey() {
      getListJsonByPrimaryKey({ regionId: this.formItem.regionid }).then(
        (res) => {
          this.villagesList = res;
        }
      );
    },

    //图片上传接口
    UploadUrl: function () {
      let actionPath = this.MEMBER_HOST + "/api/common/upload";
      return actionPath;
    },
    //设置图片上传请求头
    getUpHeaders() {
      let commonBody = {
        client: "PC",
        transeq: getNowFormatDate(),
        mac: "",
        product: "GDOMALL", // 产品类型（必传参数）
        accessSource: "PC", // 访问来源（必传参数）
        version: "1.0.0", //当前请求来源的版本号（必传参数）
        sid: getSession("sid"), // 结算返回的uid（登录状态必传参数）
      };
      this.upHeaders = encryptDes(JSON.stringify(commonBody));
    },
    //将图片字符串转数组
    toArr(str) {
      if (str) {
        var _str = str.split(",");
        return _str;
      }
    },
    //上传成功
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片大小限制",
        desc: "文件 " + file.name + "太大,不能超过 2M.",
      });
    },
    //预览
    handleView(imageUrl) {
      this.showImageUrl = imageUrl;
      this.visible = true;
    },
    // 删除身份证
    handleRemoveListId(index) {
      let self = this;
      layer.confirm(
        "是否确定删除?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          layer.msg("删除成功", { icon: 1 });
          self.idUrlList.splice(index, 1);
          self.idImageUrlList.splice(index, 1);
        },
        function () {}
      );
    },
    // 删除营业执照
    handleRemoveListLicense(index) {
      let self = this;
      layer.confirm(
        "是否确定删除?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          layer.msg("删除成功", { icon: 1 });
          self.licenseUrlList.splice(index, 1);
          self.licenseImageUrlList.splice(index, 1);
        },
        function () {}
      );
    },
    // 删除店铺
    handleRemoveListShop(index) {
      let self = this;
      layer.confirm(
        "是否确定删除?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          layer.msg("删除成功", { icon: 1 });
          self.shopUrlList.splice(index, 1);
          self.shopImageUrlList.splice(index, 1);
        },
        function () {}
      );
    },
    // 删除横幅
    handleRemoveListBanner() {
      let self = this;
      layer.confirm(
        "是否确定删除?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          layer.msg("删除成功", { icon: 1 });
          self.storeBannerImg = this.storeBannerUrl = null;
        },
        function () {}
      );
    },
    handleBeforeUploadId(file) {
      const check = this.idImageUrlList.length < 2;
      if (!check) {
        this.$Message.warning("上传文件数量达到上限");
      }
      return check;
    },
    handleBeforeUploadLicense(file) {
      const check = this.licenseImageUrlList.length < 9;
      if (!check) {
        this.$Message.warning("上传文件数量达到上限");
      }
      return check;
    },
    handleBeforeUploadShop(file) {
      const check = this.shopImageUrlList.length < 9;
      if (!check) {
        this.$Message.warning("上传文件数量达到上限");
      }
      return check;
    },
    //上传失败
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "请选择jpg、png或者jpeg.",
      });
    },
    //身份证上传成功
    handleSuccessListId(res, file) {
      this.$Message.success(res.resDesc);
      if (res.resCode == 1) {
        var localImage = res.data.fileDetailUrl;
        var image = res.data.fileUrl;
        this.idImageUrlList.push(localImage);
        this.idUrlList.push(image);
      } else {
        this.$Message.error("上传失败");
      }
    },
    //营业执照上传成功
    handleSuccessListLicense(res, file) {
      this.$Message.success(res.resDesc);
      if (res.resCode == 1) {
        var localImage = res.data.fileDetailUrl;
        var image = res.data.fileUrl;
        this.noIdImg = false;
        this.licenseImageUrlList.push(localImage);
        this.licenseUrlList.push(image);
      } else {
        this.$Message.error("上传失败");
      }
    },
    //横幅上传成功
    handleSuccessListBanner(res, file) {
      this.$Message.success(res.resDesc);
      if (res.resCode == 1) {
        var localImage = res.data.fileDetailUrl;
        var image = res.data.fileUrl;
        this.storeBannerImg = localImage;
        this.storeBannerUrl = image;
      } else {
        this.$Message.error("上传失败");
      }
    },
    //店铺上传成功
    handleSuccessListShop(res, file) {
      this.$Message.success(res.resDesc);
      if (res.resCode == 1) {
        var localImage = res.data.fileDetailUrl;
        var image = res.data.fileUrl;
        this.shopImageUrlList.push(localImage);
        this.shopUrlList.push(image);
      } else {
        this.$Message.error("上传失败");
      }
    },
    //提交申请
    handleSubmit() {
      if (!this.formItem.name || this.formItem.name.trim().length === 0) {
        this.$Message.warning("姓名不能为空");
        return;
      }
      if (
        !this.formItem.leagueName ||
        this.formItem.leagueName.trim().length === 0
      ) {
        this.$Message.warning("商家店铺不能为空");
        return;
      }
      if (
        !this.formItem.provinceid ||
        !this.formItem.cityid ||
        !this.formItem.regionid ||
        !this.formItem.villagesid
      ) {
        this.$Message.warning("地区选择不能为空!");
        return;
      }
      if (!this.formItem.attr || !this.formItem.attr.trim()) {
        this.$Message.warning("详细地址不能为空");
        return;
      }
      if (!this.formItem.tel || this.formItem.tel.trim().length === 0) {
        this.$Message.warning("手机号不能为空");
        return;
      }
      if (!this.formItem.legionId) {
        this.$Message.warning("所属市场不能为空");
        return;
      }
      if (this.formItem.tel && this.formItem.tel.trim().length > 0) {
        // 验证手机号码
        // const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
        const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.formItem.tel)) {
          this.$Message.warning("手机格式不正确!");
          return;
        }
      }
      if (
        !this.formItem.uniformSocialCreditCode ||
        !this.formItem.uniformSocialCreditCode.trim()
      ) {
        this.$Message.warning("注册号/社会统一代码不能为空");
        return;
      }
      if (
        !this.formItem.idNumber ||
        this.formItem.idNumber.trim().length === 0
      ) {
        this.$Message.warning("身份证号不能为空");
        return;
      }
      if (this.formItem.idNumber && this.formItem.idNumber.trim().length > 0) {
        // 验证身份证
        const myreg = /^(\d{18,18}|\d{15,15}|\d{17,17}X)$/;
        if (!myreg.test(this.formItem.idNumber)) {
          this.$Message.warning("身份证格式不正确!");
          return;
        }
      }
      if (!this.idImageUrlList || this.idImageUrlList.length === 0) {
        this.$Message.warning("身份证照片不能为空");
        return;
      }

      if (!this.licenseImageUrlList || this.licenseImageUrlList.length === 0) {
        this.$Message.warning("营业执照照片不能为空");
        return;
      }
      if (!this.storeBannerImg || this.storeBannerImg.length === 0) {
        this.$Message.warning("店铺横幅图片不能为空");
        return;
      }
      let params = {
        leagueId: this.formItem.leagueId,
        attr: this.formItem.attr,
        cityid: this.formItem.cityid,
        idImg: this.idImageUrlList.join(","),
        idNumber: this.formItem.idNumber,
        leagueName: this.formItem.leagueName,
        licenseImg: this.licenseImageUrlList.join(","),
        localX: this.formItem.localX,
        localY: this.formItem.localY,
        name: this.formItem.name,
        provinceid: this.formItem.provinceid,
        referer: this.formItem.referer,
        regionid: this.formItem.regionid,
        shopImg: this.shopImageUrlList.join(","),
        storeBannerImg: this.storeBannerImg,
        tel: this.formItem.tel,
        parentId: this.formItem.parentId,
        catId: this.formItem.catId,
        legionId: this.formItem.legionId,
        legionName: this.formItem.legionName,
        villagesid: this.formItem.villagesid,
        uniformSocialCreditCode: this.formItem.uniformSocialCreditCode,
      };
      if (!this.formItem.catId) {
        params.parentId = 0;
        params.catId = this.formItem.parentId;
      }
      if (
        this.provinceList.filter(
          (i) => i.regionId === this.formItem.provinceid
        )[0]
      ) {
        params.provinceName = this.provinceList.filter(
          (i) => i.regionId === this.formItem.provinceid
        )[0].localName;
      }
      if (this.cityList.filter((i) => i.regionId === this.formItem.cityid)[0]) {
        params.cityName = this.cityList.filter(
          (i) => i.regionId === this.formItem.cityid
        )[0].localName;
      }
      if (
        this.regionList.filter((i) => i.regionId === this.formItem.regionid)[0]
      ) {
        params.regionName = this.regionList.filter(
          (i) => i.regionId === this.formItem.regionid
        )[0].localName;
      }
      if (
        this.villagesList.filter(
          (i) => i.regionId === this.formItem.villagesid
        )[0]
      ) {
        params.villagesName = this.villagesList.filter(
          (i) => i.regionId === this.formItem.villagesid
        )[0].localName;
      }
      //console.log(JSON.stringify(params));
      this.status === 0 ? this.reApplyLeague(params) : this.applyLeague(params);
    },
    //立即申请
    applyLeague(param) {
      var self = this;
      var lock = false;
      layer.confirm(
        "是否确定保存?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          if (!lock) {
            lock = true; //锁定
            applyLeague(param).then((res) => {
              if (res.resCode == 1) {
                layer.msg(res.resDesc, { icon: 1 });
                self.$router.push({
                  path: "/createLeague",
                });
              } else {
                layer.msg(res.resDesc, { icon: 2 });
                return;
              }
            });
          }
        },
        function () {}
      );
    },
    //重新申请
    reApplyLeague(param) {
      var self = this;
      var lock = false;
      layer.confirm(
        "是否确定保存?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          if (!lock) {
            lock = true; //锁定
            reApplyLeague(param).then((res) => {
              if (res.resCode == 1) {
                layer.msg(res.resDesc, { icon: 1 });
                self.$router.push({
                  path: "/createLeague",
                });
              } else {
                layer.msg(res.resDesc, { icon: 2 });
                return;
              }
            });
          }
        },
        function () {}
      );
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.layout-block .right-content {
  width: 850px;
  margin: 0 auto;
  padding-bottom: 30px;
  .layout {
    position: relative;
    overflow: hidden;
    margin: 0;
    padding: 0;
    z-index: 0;
    h2 {
      padding: 30px 0 20px;
      font-size: 24px;
      font-weight: 400;
      text-align: center;
    }
    .main {
      padding: 0;
      background: transparent;
      .wrap {
        background-color: #fff;
        clear: both;
        margin: 0;
        padding: 12px;
        .open-store {
          padding: 20px;
          overflow: hidden;
          min-height: 190px;
          .form-wrap {
            .s-input {
              width: 250px;
            }
            .l-input {
              width: 440px;
            }
          }
          .msgbox {
            padding: 10px 0;
            overflow: hidden;
            p {
              width: 140px;
              float: left;
              padding: 20px 14px 10px 0;
              text-align: right;
              em {
                color: red;
              }
            }
            .img_box {
              width: 600px;
              float: left;
            }
            .id_box {
              div {
                .no-img {
                  width: 100px;
                  height: 70px;
                  margin: 25px auto;
                }
                img {
                  width: 100%;
                  height: auto;
                }
                span {
                  display: block;
                  width: 100%;
                  height: 30px;
                  line-height: 30px;
                  background: #10aeff;
                  color: #fff;
                  font-size: 14px;
                  text-align: center;
                  position: absolute;
                  bottom: 0;
                }
                span:hover {
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }
}
.regis_box {
  width: 100%;
  text-align: center;
  margin-top: 50px;
  .regis_ent {
    padding: 0px;
    margin: 0px;
    height: 30px;
    line-height: 30px;
    width: 100px;
    border: medium none;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    font-family: 微软雅黑, 宋体;
    background-color: #d93600;
    color: #fff;
    outline: medium none;
    display: inline-block;
    font-size: 14px;
    border-radius: 4px;
    -moz-user-select: none;
  }

  .regis_ent:hover {
    text-decoration: none !important;
    background-color: #ff4400;
    color: #fff;
  }
}
.demo-upload-list {
  display: inline-block;
  width: 150px;
  height: 150px;
  text-align: center;
  line-height: 150px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 15px;
  img {
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover:hover {
    display: inline-block;
  }
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    i {
      font-size: 24px;
      color: #fff;
    }
  }
}
.ivu-select {
  width: 150px;
  line-height: 1.5;
  padding: 4px 0;
  font-size: 12px;
}
.layout-block:after {
  display: block;
  content: ".";
  clear: both;
  font-size: 0;
  line-height: 0;
  height: 0;
  overflow: hidden;
}

.map {
  width: 100%;
  height: 350px;
}
.mapDiv {
  position: absolute;
  left: 10px;
}
</style>



// WEBPACK FOOTER //
// applyLeague.vue?2ae26c54